module.exports = __webpack_public_path__ + "img/second-image.f7b2d137.png";